export const Theme = {}

Theme.colors = {
  lightGrey: "#e5e5e5",
  red: "#e7343f",
  darkRed: "#b22c33",
  blue: "#0098a5"
}